import { render, staticRenderFns } from "./FrightSurChargeGrid.vue?vue&type=template&id=19952ef6&"
import script from "./FrightSurChargeGrid.vue?vue&type=script&lang=js&"
export * from "./FrightSurChargeGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19952ef6')) {
      api.createRecord('19952ef6', component.options)
    } else {
      api.reload('19952ef6', component.options)
    }
    module.hot.accept("./FrightSurChargeGrid.vue?vue&type=template&id=19952ef6&", function () {
      api.rerender('19952ef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/components/grid/FrightSurChargeGrid.vue"
export default component.exports